<template>
  <section class="find-id-result">
    <auth-layout name="find-id-result">
      <template #body>
        <div class="title">
          <h3 v-text="`SMART SOLUTION ${$t('find_id')}`"></h3>
          <p v-text="$t('common.t_id_find_desc')"></p>
        </div>
        <div class="content">
          <form>
            <p v-text="$t('common.t_searched_id_cnt', { cnt: userCount })"></p>
            <fieldset>
              <p v-for="(item, index) in users" :key="index">
                <span v-text="item.email"></span>
                <span
                  v-html="
                    `&nbsp;(${item.reg_datetime} ${$t('common.fran_join')})`
                  "
                ></span>
              </p>
            </fieldset>
            <div class="button-box" @click="goLogin">
              <Button type="button" class="primary" :value="$t('login')" />
            </div>
          </form>
        </div>
      </template>
    </auth-layout>
  </section>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Vuex from 'vuex';
import authLayout from '@layouts/authLayout.vue';
import Button from '@components/Button.vue';

export default {
  name: 'findIdResult',
  head: {
    title: {
      inner: 'Find ID',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Find Your ID - Smart Solution',
      },
    ],
  },
  components: {
    authLayout,
    Button,
  },
  data() {
    return {
      users: {},
      userCount: 0,
    };
  },
  created() {
    this.users = this.getUsers();
    this.userCount = _.size(this.users);
  },
  computed: {
    ...Vuex.mapGetters(['getFoundEmailList']),
  },
  methods: {
    getUsers() {
      const users = _.map(this.getFoundEmailList, (user) => {
        return {
          email: user.email,
          reg_datetime: moment(user.reg_datetime).format('YYYY.MM.DD'),
        };
      });
      return users;
    },

    goLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped lang="scss">
.find-id-result {
  .title {
    padding: 18px 0;
    border-bottom: 1px solid $gray-e6;

    h3 {
      font-size: 14px;
      text-align: center;
    }

    p {
      margin-top: 6px;
      font-size: 12px;
      text-align: center;
      color: $gray-48;
    }
  }

  .content {
    padding: 16px 0;

    fieldset {
      margin: 7px 0;
      background-color: white;
      border: 1px solid $gray-c0;
      padding: 7px 0px;

      & + fieldset {
        margin-top: 24px;
      }

      p {
        text-align: center;
        line-height: 200%;
      }

      span {
        font-size: 12px;
        color: $gray-48;
      }
    }

    .button-box {
      width: 100%;
      padding: 12px 0;
      display: flex;
    }
  }
}
</style>
